module.exports = __webpack_public_path__ + "static/1INCH-2be041f57c759d6508ed227bedd0eeac.svg";